export default "__VITE_ASSET__5bad010a__"